"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bagnolo-cremasco": {
    "31388a5c": [{
      "hkey": "6747f486",
      "slug": "gattolino",
      "name": "Gattolino",
      "primary": true,
      "skipSearch": false
    }],
    "gatolino": [{
      "hkey": "6747f486",
      "slug": "gattolino",
      "name": "Gattolino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ec6e7991": [{
      "hkey": "cd078a0f",
      "slug": "bagnolo-cremasco",
      "name": "Bagnolo Cremasco",
      "primary": true,
      "skipSearch": false
    }],
    "moso": [{
      "hkey": "cd078a0f",
      "slug": "bagnolo-cremasco",
      "name": "Bagnolo Cremasco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;